import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import styles from "./ServiceCard.module.css";

function ServiceCard({ icon, image, title, description, href }) {
  const inner = (
    <MKBox className={`${styles.card} ${href ? styles.cardLink : ""}`} p={{ xs: 2.5, md: 3.5 }}>
      <MKBox display="flex" alignItems="center" gap={2} mb={1}>
        {image ? (
          <MKBox className={styles.imageBox}>
            <img src={image} alt={title} className={styles.cardImage} />
          </MKBox>
        ) : (
          <MKBox className={styles.iconBox} flexShrink={0}>
            <Icon className={styles.icon}>{icon}</Icon>
          </MKBox>
        )}
        <MKBox
          display="flex"
          alignItems="flex-start"
          justifyContent="space-between"
          flex={1}
          gap={1}
        >
          <MKTypography variant="h6" fontWeight="bold" className={styles.title}>
            {title}
          </MKTypography>
          {href && (
            <Icon className={styles.externalIcon} title="Abrir enlace">
              open_in_new
            </Icon>
          )}
        </MKBox>
      </MKBox>
      <MKTypography variant="body2" color="text" className={styles.description}>
        {description}
      </MKTypography>
    </MKBox>
  );

  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={styles.anchor}>
        {inner}
      </a>
    );
  }

  return inner;
}

ServiceCard.propTypes = {
  icon: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  href: PropTypes.string,
};

ServiceCard.defaultProps = {
  icon: null,
  image: null,
  href: null,
};

export default ServiceCard;
